
function detectEnvironment(): 'production' | 'beta' {
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    if (hostname.includes('admin-beta') || hostname.includes('beta')) {
      return 'beta';
    }
  }
  return 'production';
}

const getApiBaseUrl = () => {
  const env = detectEnvironment();
  return env === 'beta'
    ? 'https://beta-api.wavely.cc'
    : 'https://api.wavely.cc';
};

export const API_BASE_URL = getApiBaseUrl();

export const getEnvironment = () => {
  return detectEnvironment();
};

export const getCurrentEnvironment = () => {
  return detectEnvironment();
};

export const getApiUrl = () => {
  return API_BASE_URL;
};

// 环境判断函数
export const isDevelopment = () => getEnvironment() === 'beta';
export const isProduction = () => getEnvironment() === 'production';
export const isBeta = () => getEnvironment() === 'beta';
